import styled from 'styled-components';
import { List as MuiList, ListItem as MuiListItem, ListItemIcon as MuiListItemIcon, ListItemText as MuiListItemText } from '@material-ui/core';
import { Link as ReactLink } from 'react-router-dom';


export const List = styled(MuiList)`
  &.MuiList-root {
    margin-top: 24px;
  }
  
  &.MuiList-padding {
    padding: 0;
  }
`;
export const ListItem = styled(MuiListItem)`
  height: 40px;
  transition: all 0.2s;
  
  @media(min-width: 1920px) {
    height: 48px;
  }
  
  &.MuiButtonBase-root {
    /* padding-left: 24px; */
    border-radius: 4px;
    margin-bottom: 8px;
    padding-right: 0;
    padding-top: 0;
    padding-bottom: 0;

    /* @media(min-width: 1920px) {
      padding-left: 40px;
    } */
  }

  & .MuiListItemIcon-root {
    min-width: auto;
    margin-right: 8px;
  }

  & .MuiTypography-body1 {
    /* font-family: OpenSans-Light; */
    font-size: 1.4rem;

    @media(min-width: 1920px) {
      font-size: 1.6rem;
    }    
  }

  &:hover{
    background: var(--grayLv4);
    & .MuiTypography-body1 {
      color: var(--white);
    }

    & .MuiListItemIcon-root{
      color: var(--white);
    }
  }

  &.MuiListItem-root.Mui-selected, .MuiListItem-root.Mui-selected:hover{
    background: var(--gradientGray);
    & .MuiTypography-body1 {
      color: var(--white);
    }

    & .MuiListItemIcon-root{
      color: var(--white);
    }
  }
`;
export const Link = styled(ReactLink)`
  display: flex;
  align-items: center;
`;
export const ListItemIcon = styled(MuiListItemIcon)`
  &.MuiListItemIcon-root {
    color: var(--grayLv4);
  }
`;
export const ListItemText = styled(MuiListItemText)`
  font-family: 'Poppins', sans-serif;
  color: var(--grayLv4);
`;